import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { accountLicenseAllocationSchema } from '../schemas/account-license-allocation.schema';

/**
 * Used by a Trimble Maps partner to get a report of all licenses and their usage accross all of their accounts.
 * @param params Paged Collection Params
 * @returns Paged Collection of Account License Allocations
 */
export function getResellerReportsLicenses(
  this: unknown,
  params?: PagedCollectionParams
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).resellerReportsLicensesUrl}${
          params ? `?${params.urlParams}` : ''
        }`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(createPagedCollectionSchema(accountLicenseAllocationSchema))
  );
}
